export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/60"></div>

      <div className="absolute top-20 right-0 w-[600px] h-[600px] rounded-full bg-primary-100/30 blur-3xl -mr-32"></div>
      <div className="absolute bottom-0 left-1/4 w-[400px] h-[400px] rounded-full bg-accent-100/25 blur-3xl"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-[1200px] mx-auto flex flex-col lg:flex-row items-center gap-8 lg:gap-12 pt-20 md:pt-24 pb-12 md:pb-16">
          <div className="flex-1 w-full">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-4">
              <i className="ri-fire-fill text-sm"></i>
              <span>全网吃瓜爆料第一站</span>
            </div>

            <h1 className="font-heading font-bold text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-3">
              每日爆料<span className="text-primary-500">·</span>一手吃瓜资讯平台
            </h1>

            <p className="font-heading text-lg md:text-xl text-primary-500 font-semibold mb-5">
              最新最全的娱乐圈八卦、社会热点、网红动态尽在掌握
            </p>

            <div className="text-foreground-700 text-sm md:text-base leading-relaxed space-y-3 mb-6 max-w-xl">
              <p>
                每日爆料是专业的吃瓜爆料资讯聚合平台，每日更新海量娱乐圈八卦、网红黑料、社会热点等一手爆料内容。无论是最新明星动态，还是热门事件深度追踪，你都能在这里第一时间获取。
              </p>
              <p>
                本站持续同步更新51每日爆料官网入口与每日爆料网官方最新地址，确保用户随时随地畅快吃瓜。平台内容由资深编辑团队7×24小时轮值审核，信息真实可靠，更新速度行业领先。
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-4 md:gap-6 mb-7">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-flashlight-fill text-accent-600 text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-600">日均更新 <strong className="text-foreground-900">200+</strong> 条爆料</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-primary-100 flex items-center justify-center">
                  <i className="ri-group-fill text-primary-600 text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-600">月活用户 <strong className="text-foreground-900">800万+</strong></span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-shield-check-fill text-accent-600 text-sm"></i>
                </div>
                <span className="text-xs md:text-sm text-foreground-600">7×24h 实时审核更新</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3">
              <a
                href="#ranking"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-fill"></i>
                立即吃瓜
              </a>
              <a
                href="#app"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border-2 border-foreground-200 text-foreground-800 font-semibold text-sm hover:border-primary-400 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-download-2-line"></i>
                下载APP更快吃瓜
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20warm-toned%20digital%20art%20with%20glowing%20social%20media%20icons%20floating%20in%20a%20vibrant%20crimson%20and%20amber%20atmosphere%2C%20dynamic%20news%20feed%20visualization%20with%20sleek%20modern%20UI%20elements%2C%20dark%20warm%20gradient%20background%20with%20pulsing%20notification%20dots%2C%20futuristic%20data%20stream%20aesthetic%2C%20high%20contrast%20editorial%20style%20with%20sophisticated%20lighting&width=960&height=720&seq=hero-main-visual&orientation=landscape"
                alt="每日爆料平台主视觉 - 吃瓜爆料资讯聚合"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/25 via-transparent to-accent-500/20"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}